var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPiccolo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 584,
    height: 606,
    viewBox: "0 0 584 606",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5131_565625)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M584 413.467L583.945 441.207C583.945 443.456 582.446 445.698 579.503 447.465L311.354 603.317C305.366 606.798 295.527 606.798 289.428 603.317L4.59985 438.729C1.55432 437.016 0 434.665 0 432.368L0.0552298 404.675C0.0552298 407.027 1.60166 409.276 4.65508 411.091L584.008 413.467H584Z",
    fill: "#117A16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.199 604.864V577.155C291.898 576.753 290.643 576.271 289.546 575.632L4.64728 411.099C1.59386 409.3 0.063209 407.011 0.063209 404.675L0.0158691 432.384C0.0158691 434.672 1.54652 437.008 4.59994 438.76L289.452 603.341C290.58 603.98 291.858 604.461 293.199 604.872",
    fill: "#2B9E31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.486 419.733C360.768 546.921 420.614 512.101 311.409 575.601C305.42 579.136 295.581 579.136 289.522 575.601L18.7302 419.228L4.67027 411.091C3.97595 410.713 3.40787 410.271 2.90291 409.829C-1.38134 406.356 -0.821153 401.503 4.54403 398.409L272.622 242.541C278.673 239.006 288.449 239.006 294.501 242.541L579.423 407.051C585.475 410.586 585.538 416.261 579.486 419.733Z",
    fill: "#55BE5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.202 485.658L95.061 372.992V204.975L290.202 317.64V485.658Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.775 312.402L113.513 292.044V234.936L148.775 255.295V312.402Z",
    fill: "#FF3F83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.62 257.052L117.854 250.836V241.935L128.62 248.15V257.052Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.432 266.18L133.666 259.965V251.063L144.432 257.279V266.18Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.62 270.125L117.854 263.91V255.008L128.62 261.223V270.125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.432 279.254L133.666 273.039V264.138L144.432 270.353V279.254Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.62 283.2L117.854 276.984V268.082L128.62 274.298V283.2Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.432 292.328L133.666 286.112V277.211L144.432 283.427V292.328Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.62 296.273L117.854 290.058V281.156L128.62 287.372V296.273Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.432 305.403L133.666 299.187V290.286L144.432 296.501V305.403Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.775 384.13L113.513 363.773V306.666L148.775 327.023V384.13Z",
    fill: "#FF3F83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.62 328.781L117.854 322.565V313.664L128.62 319.88V328.781Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.432 337.91L133.666 331.695V322.793L144.432 329.009V337.91Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.62 341.855L117.854 335.639V326.738L128.62 332.954V341.855Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.432 350.984L133.666 344.768V335.866L144.432 342.083V350.984Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.62 354.928L117.854 348.713V339.812L128.62 346.027V354.928Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.432 364.057L133.666 357.842V348.94L144.432 355.156V364.057Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.62 368.003L117.854 361.788V352.887L128.62 359.101V368.003Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.432 377.132L133.666 370.917V362.015L144.432 368.231V377.132Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.263 347.902L175.001 327.544V270.437L210.263 290.795V347.902Z",
    fill: "#FF3F83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.108 292.552L179.342 286.336V277.435L190.108 283.651V292.552Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.921 301.68L195.155 295.465V286.563L205.921 292.779V301.68Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.108 305.625L179.342 299.41V290.509L190.108 296.723V305.625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.921 314.754L195.155 308.539V299.638L205.921 305.853V314.754Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.263 439.504L175.001 419.146V360.22L210.263 380.579V439.504Z",
    fill: "#FF0F64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.179 421.558L190.947 428.352V373.389L179.179 366.596V421.558Z",
    fill: "#FF3F83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.316 430.297L206.084 437.092V382.128L194.316 375.334V430.297Z",
    fill: "#FF3F83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.751 383.402L236.489 363.044V305.937L271.751 326.295V383.402Z",
    fill: "#FF3F83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.597 328.052L240.831 321.836V312.935L251.597 319.151V328.052Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.409 337.18L256.643 330.965V322.063L267.409 328.279V337.18Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.597 341.125L240.831 334.91V326.009L251.597 332.224V341.125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.409 350.254L256.643 344.04V335.138L267.409 341.353V350.254Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.597 354.2L240.831 347.984V339.083L251.597 345.298V354.2Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.409 363.328L256.643 357.112V348.211L267.409 354.427V363.328Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.597 367.275L240.831 361.058V352.157L251.597 358.373V367.275Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.409 376.403L256.643 370.187V361.286L267.409 367.502V376.403Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.751 455.131L236.489 434.773V377.666L271.751 398.024V455.131Z",
    fill: "#FF3F83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.597 399.782L240.831 393.566V384.664L251.597 390.88V399.782Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.409 408.911L256.643 402.695V393.794L267.409 400.01V408.911Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.597 412.855L240.831 406.64V397.738L251.597 403.954V412.855Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.409 421.985L256.643 415.768V406.867L267.409 413.084V421.985Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.597 425.929L240.831 419.713V410.812L251.597 417.028V425.929Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.409 435.058L256.643 428.842V419.941L267.409 426.156V435.058Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.597 439.003L240.831 432.788V423.887L251.597 430.102V439.003Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.409 448.133L256.643 441.917V433.015L267.409 439.231V448.133Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.478 338.211L191.785 337.234V280.126L193.478 281.104V338.211Z",
    fill: "#FF0F64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.202 309.008L95.061 196.343V204.974L290.202 317.64V309.008Z",
    fill: "#FF0F64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.061 196.343L290.202 93.8994V309.008L95.061 196.343Z",
    fill: "#FF3F83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.645 235.872L95.061 229.762V216.553L105.645 222.663V235.872Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.645 261.418L95.061 255.307V242.097L105.645 248.209V261.418Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.645 286.963L95.061 280.852V267.643L105.645 273.754V286.963Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.645 312.508L95.061 306.398V293.188L105.645 299.299V312.508Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.645 338.055L95.061 331.943V318.733L105.645 324.845V338.055Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.645 363.6L95.061 357.488V344.279L105.645 350.39V363.6Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.618 336.316L290.202 342.427V329.218L279.618 323.105V336.316Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.618 361.861L290.202 367.972V354.763L279.618 348.651V361.861Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.618 387.406L290.202 393.518V380.308L279.618 374.196V387.406Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.618 412.951L290.202 419.063V405.853L279.618 399.742V412.951Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.618 438.496L290.202 444.609V431.398L279.618 425.287V438.496Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.618 464.041L290.202 470.153V456.943L279.618 450.833V464.041Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.202 498.207L95.061 385.542V372.992L290.202 485.658V498.207Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.346 196.343L290.202 93.8994V309.008L485.346 196.343Z",
    fill: "#FF0F64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.346 372.992L290.202 485.658V317.64L485.346 204.975V372.992Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.916 363.044L308.656 383.402V326.295L343.916 305.937V363.044Z",
    fill: "#FF3F83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.764 330.965L312.997 337.18V328.279L323.764 322.063V330.965Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.575 321.836L328.809 328.052V319.151L339.575 312.935V321.836Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.764 344.04L312.997 350.254V341.353L323.764 335.138V344.04Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.575 334.91L328.809 341.125V332.224L339.575 326.009V334.91Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.764 357.112L312.997 363.328V354.427L323.764 348.211V357.112Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.575 347.984L328.809 354.2V345.298L339.575 339.083V347.984Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.764 370.187L312.997 376.403V367.502L323.764 361.286V370.187Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.575 361.058L328.809 367.275V358.373L339.575 352.157V361.058Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.916 434.773L308.656 455.131V398.024L343.916 377.666V434.773Z",
    fill: "#FF3F83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.764 402.695L312.997 408.911V400.01L323.764 393.794V402.695Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.575 393.566L328.809 399.782V390.88L339.575 384.664V393.566Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.764 415.768L312.997 421.985V413.084L323.764 406.867V415.768Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.575 406.64L328.809 412.855V403.954L339.575 397.738V406.64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.764 428.842L312.997 435.058V426.156L323.764 419.941V428.842Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.575 419.713L328.809 425.929V417.028L339.575 410.812V419.713Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.764 441.917L312.997 448.133V439.231L323.764 433.015V441.917Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.575 432.788L328.809 439.003V430.102L339.575 423.887V432.788Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.893 292.044L431.631 312.402V255.295L466.893 234.936V292.044Z",
    fill: "#FF3F83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.739 259.965L435.973 266.18V257.279L446.739 251.063V259.965Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.551 250.836L451.785 257.052V248.15L462.551 241.935V250.836Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.739 273.039L435.973 279.254V270.353L446.739 264.138V273.039Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.551 263.91L451.785 270.125V261.223L462.551 255.008V263.91Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.739 286.112L435.973 292.328V283.427L446.739 277.211V286.112Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.551 276.984L451.785 283.2V274.298L462.551 268.082V276.984Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.739 299.187L435.973 305.403V296.501L446.739 290.286V299.187Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.551 290.058L451.785 296.273V287.372L462.551 281.156V290.058Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.893 363.773L431.631 384.13V327.023L466.893 306.666V363.773Z",
    fill: "#FF3F83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.739 331.695L435.973 337.91V329.009L446.739 322.793V331.695Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.551 322.565L451.785 328.781V319.88L462.551 313.664V322.565Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.739 344.768L435.973 350.984V342.083L446.739 335.866V344.768Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.551 335.639L451.785 341.855V332.954L462.551 326.738V335.639Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.739 357.842L435.973 364.057V355.156L446.739 348.94V357.842Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.551 348.713L451.785 354.928V346.027L462.551 339.812V348.713Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.739 370.917L435.973 377.132V368.231L446.739 362.015V370.917Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.551 361.788L451.785 368.003V359.101L462.551 352.887V361.788Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.251 327.054L370.99 347.413V290.306L406.251 269.947V327.054Z",
    fill: "#FF3F83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.097 294.976L375.331 301.193V292.291L386.097 286.074V294.976Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.909 285.847L391.144 292.063V283.162L401.909 276.946V285.847Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.097 308.05L375.331 314.265V305.364L386.097 299.148V308.05Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.909 298.921L391.144 305.136V296.234L401.909 290.02V298.921Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.097 321.123L375.331 327.339V318.438L386.097 312.222V321.123Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.909 311.995L391.144 318.21V309.308L401.909 303.094V311.995Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.097 334.198L375.331 340.413V331.512L386.097 325.297V334.198Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.909 325.069L391.144 331.285V322.384L401.909 316.168V325.069Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.251 398.784L370.99 419.142V362.035L406.251 341.677V398.784Z",
    fill: "#FF3F83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.097 366.706L375.331 372.921V364.02L386.097 357.805V366.706Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.909 357.577L391.144 363.792V354.89L401.909 348.675V357.577Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.097 379.779L375.331 385.995V377.094L386.097 370.878V379.779Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.909 370.651L391.144 376.866V367.965L401.909 361.749V370.651Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.097 392.853L375.331 399.069V390.167L386.097 383.952V392.853Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.909 383.723L391.144 389.94V381.039L401.909 374.822V383.723Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.097 405.927L375.331 412.144V403.242L386.097 397.025V405.927Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.909 396.799L391.144 403.014V394.113L401.909 387.897V396.799Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.621 337.234L386.928 338.211V281.104L388.621 280.126V337.234Z",
    fill: "#FF0F64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.346 196.343L290.202 309.008V317.64L485.346 204.974V196.343Z",
    fill: "#9E0038"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.788 336.316L290.202 342.427V329.218L300.788 323.105V336.316Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.788 361.861L290.202 367.972V354.763L300.788 348.651V361.861Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.788 387.406L290.202 393.518V380.308L300.788 374.196V387.406Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.788 412.951L290.202 419.063V405.853L300.788 399.742V412.951Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.788 438.496L290.202 444.609V431.398L300.788 425.287V438.496Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.788 464.041L290.202 470.153V456.943L300.788 450.833V464.041Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.761 235.872L485.346 229.762V216.553L474.761 222.663V235.872Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.761 261.418L485.346 255.307V242.097L474.761 248.209V261.418Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.761 286.963L485.346 280.852V267.643L474.761 273.754V286.963Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.761 312.508L485.346 306.398V293.188L474.761 299.299V312.508Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.761 338.055L485.346 331.943V318.733L474.761 324.845V338.055Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.761 363.6L485.346 357.488V344.279L474.761 350.39V363.6Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.346 385.542L290.202 498.207V485.658L485.346 372.992V385.542Z",
    fill: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.797 476.779L311.598 477.011C311.598 477.011 312.411 482.37 318.696 483.824L319.457 484.258L319.657 484.027L319.539 483.667C316.847 476.584 314.214 476.289 311.797 476.779Z",
    fill: "#77CB7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.796 473.052C320.387 473.76 318.143 475.281 318.953 482.964L319.012 483.345L319.298 483.46L319.787 482.705C324.801 478.396 323.083 473.166 323.083 473.166L322.796 473.052Z",
    fill: "#77CB7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.556 474.513L326.335 474.676C326.335 474.676 325.996 479.548 331.23 482.111L331.813 482.648L332.034 482.486L332.001 482.146C331.03 475.374 328.775 474.577 326.556 474.513Z",
    fill: "#77CB7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.335 474.676C326.335 474.676 326.696 475.252 331.813 482.648L331.78 482.309C330.809 475.537 328.555 474.74 326.335 474.676Z",
    fill: "#77CB7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.951 482.245L331.706 482.604L331.853 482.926L332.833 482.697C340.248 483.164 342.85 477.505 342.85 477.505L342.703 477.183C340.185 475.842 337.178 475.298 331.951 482.245Z",
    fill: "#77CB7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.768 472.784L315.638 473.074C315.638 473.074 318.007 478.131 324.653 477.663L325.533 477.862L325.663 477.572L325.441 477.252C320.71 471.057 318.017 471.565 315.768 472.784Z",
    fill: "#77CB7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.644 461.856C329.085 461.959 325.469 463.238 323.912 474.097L323.859 474.642L324.213 474.903L325.148 474.041C333.541 469.931 332.997 462.118 332.997 462.118L332.644 461.856Z",
    fill: "#77CB7B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M325.239 483.091C317.172 483.091 313.577 488.739 313.484 490.436C313.383 492.283 314.529 494.149 316.923 495.559C319.219 496.911 322.229 497.587 325.239 497.587C328.249 497.587 331.259 496.911 333.556 495.559C335.95 494.149 337.096 492.283 336.995 490.436C336.995 487.695 333.306 483.091 325.239 483.091Z",
    fill: "#77CB7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.675 471.697C312.293 472.098 312.302 472.74 312.696 473.129C319.309 479.679 319.282 488.351 319.281 488.438C319.274 488.997 319.711 489.456 320.259 489.465C320.264 489.465 320.269 489.465 320.274 489.465C320.816 489.465 321.259 489.022 321.267 488.467C321.273 488.078 321.327 478.853 314.079 471.676C313.686 471.286 313.057 471.295 312.675 471.697Z",
    fill: "#55BE5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.53 470.025C330.185 476.501 329.433 487.784 329.404 488.261C329.371 488.82 329.788 489.3 330.335 489.334C330.356 489.335 330.376 489.336 330.396 489.336C330.917 489.336 331.355 488.922 331.387 488.384C331.393 488.276 332.11 477.481 338.829 471.558C339.244 471.192 339.29 470.552 338.931 470.129C338.572 469.706 337.945 469.659 337.53 470.025Z",
    fill: "#55BE5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.392 468.273C315.605 467.982 315.77 467.703 315.863 467.447C316.026 467.017 315.705 466.366 315.705 466.366C315.705 466.366 315.424 466.259 314.965 466.176C313.64 465.938 312.538 466.71 311.7 467.748C311.416 466.832 310.645 466.321 308.897 467.157C306.868 468.127 306.95 469.358 307.6 470.346C306.116 470.773 304.856 471.511 304.784 472.762C304.773 472.962 304.713 472.999 304.713 472.999C304.713 472.999 304.948 472.987 304.858 473.174C305.591 473.764 306.813 473.685 307.534 473.448C306.943 474.297 306.642 475.298 306.642 475.298C306.642 475.298 306.797 475.734 307.813 475.732C309.263 475.711 310.478 475.269 311.073 474.256C312.047 474.787 313.069 474.513 314.471 473.21C315.655 471.986 315.234 471.496 315.234 471.496C315.234 471.496 315.221 471.576 315.061 471.459C316.583 471.016 317.678 469.999 317.717 468.735C317.723 468.379 317.69 468.203 317.612 468.059C317.294 467.471 316.526 467.92 315.392 468.273Z",
    fill: "#00369A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.358 470.305C309.269 471.103 309.843 471.655 310.316 471.667C311.797 471.705 317.641 471.325 317.724 468.619C317.808 465.914 311.447 469.507 310.358 470.305Z",
    fill: "#0047CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.77 465.8C311.643 465.238 309.759 470.306 309.653 471.208C309.547 472.109 310.756 471.816 311.228 471.491C312.704 470.473 317.898 466.362 314.77 465.8Z",
    fill: "#0047CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.702 466.781C304.903 468.597 308.504 471.327 309.379 471.667C310.253 472.007 311.165 471.15 311.292 470.752C311.687 469.507 312.501 464.964 308.702 466.781Z",
    fill: "#0047CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.013 469.431C310.547 469.369 304.746 469.659 304.589 472.387C304.432 475.115 310.833 471.592 311.934 470.805C313.035 470.017 312.482 469.451 312.013 469.431Z",
    fill: "#0047CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.004 470.105C308.719 471.258 304.355 475.783 307.891 475.732C311.427 475.681 311.941 470.892 311.785 470.08C311.629 469.268 310.415 469.737 310.004 470.105Z",
    fill: "#0047CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.337 470.297C309.132 470.434 308.723 471.36 308.862 471.668C309.296 472.634 311.578 475.899 314.507 473.176C317.437 470.452 311.543 470.16 310.337 470.297Z",
    fill: "#0047CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.441 469.053C309.11 469.714 308.294 470.908 308.619 471.718C308.944 472.529 310.286 472.649 311.618 471.988C312.949 471.326 313.764 470.133 313.439 469.323C313.114 468.512 311.772 468.391 310.441 469.053Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.138 461.941C317.717 461.536 317.054 461.555 316.656 461.984C316.259 462.414 316.278 463.09 316.699 463.495C326.058 472.508 325.502 490.396 325.496 490.576C325.474 491.165 325.924 491.662 326.502 491.684C326.516 491.685 326.53 491.685 326.544 491.685C327.103 491.685 327.568 491.234 327.59 490.658C327.619 489.886 328.195 471.626 318.138 461.941Z",
    fill: "#55BE5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.326 471.07C347.326 471.07 347.239 471.032 347.187 470.767C346.858 469.105 345.034 468.36 342.967 468.076C343.654 466.627 343.536 464.963 340.639 464.056C338.144 463.275 337.207 464.108 336.995 465.39C335.681 464.162 334.062 463.341 332.332 463.916C331.734 464.115 331.377 464.312 331.377 464.312C331.377 464.312 331.067 465.247 331.366 465.791C331.539 466.116 331.811 466.458 332.15 466.806C330.567 466.552 329.454 466.099 329.138 466.948C329.06 467.156 329.05 467.399 329.123 467.873C329.41 469.559 331.065 470.708 333.186 471.007C332.993 471.195 332.96 471.091 332.96 471.091C332.96 471.091 332.488 471.828 334.301 473.238C336.42 474.712 337.839 474.881 339.043 473.981C340.03 475.223 341.738 475.58 343.684 475.328C345.044 475.134 345.17 474.52 345.17 474.52C345.17 474.52 344.581 473.238 343.633 472.216C344.642 472.394 346.293 472.263 347.164 471.333C347.01 471.099 347.326 471.07 347.326 471.07Z",
    fill: "#00369A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.268 468.553C337.662 467.695 328.478 464.113 329.092 467.719C329.706 471.326 337.601 470.705 339.577 470.369C340.209 470.261 340.874 469.411 339.268 468.553Z",
    fill: "#0047CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.523 463.375C328.44 464.732 336.159 469.232 338.323 470.309C339.015 470.653 340.689 470.813 340.38 469.626C340.071 468.439 336.607 462.018 332.523 463.375Z",
    fill: "#0047CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.83 463.516C335.407 461.818 337.34 467.743 338.101 469.334C338.344 469.842 339.724 470.813 340.832 470.189C341.939 469.564 346.254 465.214 340.83 463.516Z",
    fill: "#0047CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.889 467.703C336.265 467.82 335.63 468.685 337.25 469.527C338.87 470.368 348.095 473.848 347.378 470.226C346.661 466.603 338.841 467.337 336.889 467.703Z",
    fill: "#0047CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.704 468.217C339.086 467.804 337.373 467.41 337.315 468.527C337.258 469.645 338.834 475.958 343.578 475.342C348.323 474.727 341.639 469.512 339.704 468.217Z",
    fill: "#0047CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.294 468.539C337.655 468.588 329.817 470.119 334.246 473.199C338.674 476.279 341.122 471.466 341.524 470.09C341.652 469.65 340.933 468.49 339.294 468.539Z",
    fill: "#0047CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.924 466.893C337.019 466.265 335.244 466.686 334.959 467.834C334.675 468.982 335.989 470.422 337.894 471.05C339.799 471.679 341.574 471.258 341.858 470.11C342.143 468.962 340.829 467.522 338.924 466.893Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.034 459.426C324.923 458.8 326.072 457.459 326.055 456.101C325.77 456.041 325.987 455.781 325.987 455.781C325.987 455.781 325.895 455.818 325.663 455.657C324.212 454.653 322.298 455.465 320.535 456.808C320.004 455.199 318.711 454.034 315.871 455.532C313.425 456.823 313.322 458.156 314.091 459.281C312.211 459.346 310.397 459.947 309.51 461.683C309.203 462.284 309.077 462.701 309.077 462.701C309.077 462.701 309.52 463.638 310.14 463.824C310.504 463.938 310.957 463.991 311.465 463.998C310.088 464.999 308.921 465.496 309.297 466.373C309.39 466.589 309.557 466.78 309.956 467.082C311.392 468.136 313.472 467.755 315.287 466.384C315.277 466.67 315.177 466.616 315.177 466.616C315.177 466.616 315.355 467.527 317.741 467.224C320.405 466.739 321.597 465.798 321.854 464.213C323.496 464.406 325.042 463.389 326.325 461.733C327.21 460.562 326.86 460.004 326.86 460.004C326.86 460.004 325.488 459.482 324.034 459.426Z",
    fill: "#00369A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.093 459.953C316.262 460.516 306.748 464.734 309.821 466.989C312.895 469.244 318.395 462.83 319.641 461.088C320.039 460.532 319.925 459.39 318.093 459.953Z",
    fill: "#0047CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.707 459.925C318.615 459.263 311.357 457.033 309.262 461.131C307.167 465.229 316.242 462.807 318.653 461.988C319.423 461.727 320.799 460.586 319.707 459.925Z",
    fill: "#0047CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.624 454.98C310.308 457.785 316.054 460.795 317.778 461.42C318.329 461.62 320.072 461.312 320.455 460.008C320.838 458.703 320.94 452.175 315.624 454.98Z",
    fill: "#0047CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.415 455.106C322.253 452.916 316.89 459.359 315.685 461.105C315.299 461.663 315.447 462.793 317.277 462.207C319.107 461.621 328.578 457.296 325.415 455.106Z",
    fill: "#0047CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.179 459.373C317.414 459.526 315.838 460.52 316.603 461.405C317.369 462.291 323.127 465.86 326.256 461.824C329.386 457.787 320.574 458.891 318.179 459.373Z",
    fill: "#0047CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.103 459.924C316.903 461.195 312.105 468.251 317.672 467.238C323.239 466.224 321.599 460.753 320.906 459.413C320.684 458.985 319.302 458.652 318.103 459.924Z",
    fill: "#0047CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.632 458.962C314.742 459.923 313.709 461.577 314.326 462.657C314.942 463.736 316.975 463.832 318.865 462.871C320.756 461.909 321.789 460.255 321.172 459.175C320.555 458.096 318.523 458 316.632 458.962Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.797 396.779L467.598 397.011C467.598 397.011 468.411 402.37 474.696 403.824L475.457 404.258L475.657 404.027L475.539 403.667C472.847 396.584 470.214 396.289 467.797 396.779Z",
    fill: "#77CB7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.796 393.052C476.387 393.76 474.143 395.281 474.953 402.964L475.012 403.345L475.298 403.46L475.787 402.705C480.801 398.396 479.083 393.166 479.083 393.166L478.796 393.052Z",
    fill: "#77CB7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.556 394.513L482.336 394.676C482.336 394.676 481.996 399.548 487.23 402.111L487.813 402.648L488.034 402.486L488.001 402.146C487.03 395.374 484.775 394.577 482.556 394.513Z",
    fill: "#77CB7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.335 394.676C482.335 394.676 482.696 395.252 487.813 402.648L487.78 402.309C486.809 395.537 484.555 394.74 482.335 394.676Z",
    fill: "#77CB7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487.951 402.245L487.706 402.604L487.853 402.926L488.833 402.697C496.248 403.164 498.85 397.505 498.85 397.505L498.703 397.183C496.185 395.842 493.178 395.298 487.951 402.245Z",
    fill: "#77CB7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.767 392.784L471.638 393.074C471.638 393.074 474.007 398.131 480.653 397.663L481.533 397.862L481.662 397.572L481.441 397.252C476.709 391.057 474.017 391.565 471.767 392.784Z",
    fill: "#77CB7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.644 381.856C485.085 381.959 481.469 383.238 479.912 394.097L479.859 394.642L480.213 394.903L481.148 394.041C489.542 389.931 488.997 382.118 488.997 382.118L488.644 381.856Z",
    fill: "#77CB7B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M481.239 403.091C473.172 403.091 469.577 408.739 469.484 410.436C469.383 412.283 470.529 414.149 472.923 415.559C475.219 416.911 478.229 417.587 481.239 417.587C484.249 417.587 487.259 416.911 489.556 415.559C491.95 414.149 493.096 412.283 492.995 410.436C492.995 407.695 489.306 403.091 481.239 403.091Z",
    fill: "#77CB7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.675 391.697C468.293 392.098 468.302 392.74 468.696 393.129C475.309 399.679 475.282 408.351 475.281 408.438C475.274 408.997 475.711 409.456 476.259 409.465C476.264 409.465 476.27 409.465 476.275 409.465C476.816 409.465 477.259 409.022 477.267 408.467C477.273 408.078 477.327 398.853 470.079 391.676C469.686 391.286 469.057 391.295 468.675 391.697Z",
    fill: "#55BE5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.53 390.025C486.185 396.501 485.433 407.784 485.404 408.261C485.371 408.82 485.788 409.3 486.335 409.334C486.356 409.335 486.376 409.336 486.396 409.336C486.917 409.336 487.355 408.922 487.387 408.384C487.393 408.276 488.11 397.481 494.829 391.558C495.244 391.192 495.29 390.552 494.931 390.129C494.572 389.706 493.945 389.659 493.53 390.025Z",
    fill: "#55BE5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.392 388.273C471.605 387.982 471.77 387.703 471.863 387.447C472.026 387.017 471.705 386.366 471.705 386.366C471.705 386.366 471.424 386.259 470.965 386.176C469.64 385.938 468.538 386.71 467.7 387.748C467.416 386.832 466.645 386.321 464.897 387.157C462.868 388.127 462.95 389.358 463.6 390.346C462.116 390.773 460.856 391.511 460.784 392.762C460.773 392.962 460.713 392.999 460.713 392.999C460.713 392.999 460.948 392.987 460.858 393.174C461.591 393.764 462.813 393.685 463.534 393.448C462.943 394.297 462.642 395.298 462.642 395.298C462.642 395.298 462.797 395.734 463.813 395.732C465.263 395.711 466.478 395.269 467.073 394.256C468.047 394.787 469.069 394.513 470.471 393.21C471.655 391.986 471.234 391.496 471.234 391.496C471.234 391.496 471.221 391.576 471.061 391.459C472.583 391.016 473.678 389.999 473.717 388.735C473.723 388.379 473.69 388.203 473.612 388.059C473.294 387.471 472.526 387.92 471.392 388.273Z",
    fill: "#00369A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.358 390.305C465.269 391.103 465.843 391.655 466.316 391.667C467.797 391.705 473.641 391.325 473.724 388.619C473.808 385.914 467.447 389.507 466.358 390.305Z",
    fill: "#0047CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.77 385.8C467.642 385.238 465.758 390.306 465.653 391.208C465.547 392.109 466.756 391.816 467.228 391.491C468.703 390.473 473.898 386.362 470.77 385.8Z",
    fill: "#0047CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.702 386.781C460.903 388.597 464.504 391.327 465.379 391.667C466.253 392.007 467.165 391.15 467.291 390.752C467.687 389.507 468.5 384.964 464.702 386.781Z",
    fill: "#0047CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.013 389.431C466.547 389.369 460.746 389.659 460.589 392.387C460.432 395.115 466.833 391.592 467.934 390.805C469.035 390.017 468.482 389.451 468.013 389.431Z",
    fill: "#0047CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.004 390.105C464.719 391.258 460.355 395.783 463.891 395.732C467.427 395.681 467.941 390.892 467.785 390.08C467.629 389.268 466.415 389.737 466.004 390.105Z",
    fill: "#0047CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.337 390.297C465.132 390.434 464.723 391.36 464.862 391.668C465.296 392.634 467.577 395.899 470.507 393.176C473.436 390.452 467.542 390.16 466.337 390.297Z",
    fill: "#0047CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.44 389.053C465.109 389.714 464.294 390.908 464.619 391.718C464.944 392.529 466.286 392.649 467.617 391.988C468.949 391.326 469.764 390.133 469.439 389.323C469.114 388.512 467.772 388.391 466.44 389.053Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.137 381.941C473.717 381.536 473.053 381.555 472.656 381.984C472.259 382.414 472.278 383.09 472.699 383.495C482.058 392.508 481.502 410.396 481.495 410.576C481.474 411.165 481.924 411.662 482.502 411.684C482.516 411.685 482.53 411.685 482.543 411.685C483.103 411.685 483.568 411.234 483.59 410.658C483.619 409.886 484.194 391.626 474.137 381.941Z",
    fill: "#55BE5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.326 391.07C503.326 391.07 503.239 391.032 503.187 390.767C502.858 389.105 501.034 388.36 498.967 388.076C499.654 386.627 499.536 384.963 496.639 384.056C494.144 383.275 493.207 384.108 492.995 385.39C491.681 384.162 490.062 383.341 488.332 383.916C487.734 384.115 487.377 384.312 487.377 384.312C487.377 384.312 487.067 385.247 487.366 385.791C487.539 386.116 487.811 386.458 488.15 386.806C486.567 386.552 485.454 386.099 485.138 386.948C485.06 387.156 485.05 387.399 485.123 387.873C485.41 389.559 487.065 390.708 489.186 391.007C488.993 391.195 488.96 391.091 488.96 391.091C488.96 391.091 488.488 391.828 490.301 393.238C492.42 394.712 493.839 394.881 495.043 393.981C496.03 395.223 497.738 395.58 499.684 395.328C501.044 395.134 501.17 394.52 501.17 394.52C501.17 394.52 500.581 393.238 499.633 392.216C500.642 392.394 502.293 392.263 503.164 391.333C503.01 391.099 503.326 391.07 503.326 391.07Z",
    fill: "#00369A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.268 388.553C493.662 387.695 484.478 384.113 485.092 387.719C485.706 391.326 493.601 390.705 495.577 390.369C496.209 390.261 496.874 389.411 495.268 388.553Z",
    fill: "#0047CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.523 383.375C484.44 384.732 492.158 389.232 494.323 390.309C495.015 390.653 496.689 390.813 496.379 389.626C496.07 388.439 492.607 382.018 488.523 383.375Z",
    fill: "#0047CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.83 383.516C491.407 381.818 493.34 387.743 494.101 389.334C494.344 389.842 495.724 390.813 496.832 390.189C497.939 389.564 502.254 385.214 496.83 383.516Z",
    fill: "#0047CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.889 387.703C492.265 387.82 491.629 388.685 493.25 389.527C494.87 390.368 504.095 393.848 503.378 390.226C502.661 386.603 494.841 387.337 492.889 387.703Z",
    fill: "#0047CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.704 388.217C495.086 387.804 493.373 387.41 493.315 388.527C493.258 389.645 494.835 395.958 499.579 395.342C504.323 394.727 497.639 389.512 495.704 388.217Z",
    fill: "#0047CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.294 388.539C493.655 388.588 485.818 390.119 490.246 393.199C494.674 396.279 497.122 391.466 497.524 390.09C497.653 389.65 496.933 388.49 495.294 388.539Z",
    fill: "#0047CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.924 386.893C493.019 386.265 491.244 386.686 490.96 387.834C490.675 388.982 491.989 390.422 493.894 391.05C495.799 391.679 497.574 391.258 497.859 390.11C498.143 388.962 496.83 387.522 494.924 386.893Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.033 379.426C480.923 378.8 482.072 377.459 482.055 376.101C481.77 376.041 481.987 375.781 481.987 375.781C481.987 375.781 481.895 375.818 481.663 375.657C480.212 374.653 478.298 375.465 476.535 376.808C476.004 375.199 474.711 374.034 471.871 375.532C469.425 376.823 469.322 378.156 470.09 379.281C468.211 379.346 466.397 379.947 465.51 381.683C465.202 382.284 465.077 382.701 465.077 382.701C465.077 382.701 465.52 383.638 466.139 383.824C466.504 383.938 466.957 383.991 467.465 383.998C466.087 384.999 464.921 385.496 465.297 386.373C465.389 386.589 465.557 386.78 465.956 387.082C467.392 388.136 469.472 387.755 471.286 386.384C471.277 386.67 471.177 386.616 471.177 386.616C471.177 386.616 471.354 387.527 473.741 387.224C476.405 386.739 477.596 385.798 477.853 384.213C479.495 384.406 481.042 383.389 482.325 381.733C483.209 380.562 482.86 380.004 482.86 380.004C482.86 380.004 481.488 379.482 480.033 379.426Z",
    fill: "#00369A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.093 379.953C472.262 380.516 462.748 384.734 465.821 386.989C468.895 389.244 474.395 382.83 475.641 381.088C476.039 380.532 475.925 379.39 474.093 379.953Z",
    fill: "#0047CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.707 379.925C474.615 379.263 467.357 377.033 465.262 381.131C463.167 385.229 472.242 382.807 474.653 381.988C475.423 381.727 476.799 380.586 475.707 379.925Z",
    fill: "#0047CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.623 374.98C466.308 377.785 472.054 380.795 473.778 381.42C474.329 381.62 476.072 381.312 476.455 380.008C476.838 378.703 476.939 372.175 471.623 374.98Z",
    fill: "#0047CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.415 375.106C478.253 372.916 472.891 379.359 471.685 381.105C471.3 381.663 471.447 382.793 473.277 382.207C475.108 381.621 484.578 377.296 481.415 375.106Z",
    fill: "#0047CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.179 379.373C473.414 379.526 471.838 380.52 472.603 381.405C473.369 382.291 479.127 385.86 482.256 381.824C485.386 377.787 476.574 378.891 474.179 379.373Z",
    fill: "#0047CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.103 379.924C472.903 381.195 468.105 388.251 473.672 387.238C479.239 386.224 477.599 380.753 476.906 379.413C476.684 378.985 475.302 378.652 474.103 379.924Z",
    fill: "#0047CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.633 378.962C470.742 379.923 469.709 381.577 470.326 382.657C470.943 383.736 472.975 383.832 474.865 382.871C476.756 381.909 477.789 380.255 477.172 379.175C476.556 378.096 474.523 378 472.633 378.962Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9528 373.152L45.8975 402.156L45.8817 411.081C45.8817 411.689 45.4715 412.305 44.6667 412.778C43.0414 413.725 40.3982 413.717 38.7571 412.778C37.9287 412.297 37.5183 411.673 37.5341 411.058L37.5499 402.077L37.6052 373.145C37.6052 373.768 38.0154 374.384 38.8281 374.849C40.4692 375.796 43.1123 375.796 44.7377 374.849C45.5346 374.384 45.9528 373.776 45.9528 373.152Z",
    fill: "#9E0038"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5975 382.079L37.5581 402.07C38.8126 402.748 40.2723 403.103 41.8108 403.103C43.2705 403.103 44.6749 402.788 45.8978 402.156L45.9373 382.079H37.5896H37.5975Z",
    fill: "#9E0038"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.4481 357.905L76.3928 377.485C76.3928 377.841 76.1562 378.204 75.6907 378.48C75.0516 378.851 41.5823 398.312 43.5311 397.184L43.5864 377.604L75.7459 358.9C76.2114 358.623 76.4481 358.268 76.4481 357.905Z",
    fill: "#2B9E31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5858 377.604L43.5306 397.184C42.5838 397.736 41.0531 397.736 40.0984 397.184C19.2847 385.156 24.4447 388.148 7.72586 378.48C7.24458 378.204 7 377.848 7 377.485L7.07098 357.905C7.07098 358.26 7.30769 358.631 7.7732 358.9L40.1536 377.604C41.1004 378.156 42.6311 378.156 43.5858 377.604Z",
    fill: "#99D89C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.7374 356.911C76.6921 357.464 76.6921 358.348 75.7453 358.9L43.5779 377.596C42.6311 378.149 41.1004 378.149 40.1457 377.596L7.77316 358.9C6.81847 358.348 6.81847 357.464 7.76526 356.911L39.9327 338.215C40.8795 337.663 42.4101 337.663 43.3648 338.215L75.7374 356.911Z",
    fill: "#77CB7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.1224 338.791L71.0751 355.364C71.0751 355.664 70.8778 355.972 70.4833 356.201L43.2629 372.024L43.3103 355.451L70.5307 339.628C70.9252 339.391 71.1303 339.091 71.1303 338.791H71.1224Z",
    fill: "#2B9E31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.2939 355.451L43.2466 372.024C42.4497 372.49 41.1479 372.49 40.3431 372.024L12.9491 356.209C12.5388 355.972 12.3416 355.664 12.3416 355.356L12.3889 338.791C12.3889 339.099 12.594 339.399 12.9964 339.628L40.3904 355.451C41.1952 355.917 42.4971 355.917 43.2939 355.451Z",
    fill: "#99D89C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.5136 337.946C71.3183 338.412 71.3262 339.162 70.5215 339.627L43.3011 355.451C42.5042 355.916 41.2023 355.916 40.3975 355.451L13.0035 339.627C12.1988 339.162 12.1909 338.412 12.9956 337.946L40.2161 322.123C41.0129 321.657 42.3148 321.657 43.1196 322.123L70.5136 337.946Z",
    fill: "#77CB7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6007 320.836L66.5613 334.86C66.5613 335.113 66.3956 335.373 66.0563 335.563L43.0176 348.955L43.057 334.931L66.0957 321.538C66.435 321.341 66.6007 321.089 66.6007 320.828V320.836Z",
    fill: "#2B9E31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0576 334.94L43.0182 348.964C42.3396 349.359 41.243 349.359 40.5644 348.964L17.3837 335.579C17.0365 335.382 16.8708 335.121 16.8708 334.861L16.9103 320.845C16.9103 321.105 17.0838 321.358 17.4231 321.555L40.6039 334.948C41.2824 335.342 42.387 335.342 43.0576 334.948V334.94Z",
    fill: "#99D89C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.0884 320.126C66.767 320.521 66.7749 321.16 66.0963 321.547L43.0576 334.94C42.3791 335.334 41.2824 335.334 40.6038 334.94L17.4152 321.547C16.7367 321.152 16.7288 320.513 17.4073 320.126L40.446 306.733C41.1246 306.339 42.2213 306.339 42.8998 306.733L66.0884 320.126Z",
    fill: "#77CB7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2473 320.132C32.486 320.851 32.4939 322.011 31.2631 322.729C30.0323 323.447 28.0282 323.447 26.7894 322.729C25.5507 322.011 25.5429 320.851 26.7737 320.132C28.0045 319.414 30.0086 319.414 31.2473 320.132Z",
    fill: "#FF3F83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.1051 323.711C48.1229 324.295 48.1308 325.249 47.113 325.841C46.1031 326.425 44.4541 326.425 43.4363 325.841C42.4185 325.257 42.4106 324.302 43.4205 323.711C44.4304 323.126 46.0794 323.119 47.0972 323.711H47.1051Z",
    fill: "#FF3F83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.1978 312.422C47.3497 313.085 47.3576 314.166 46.2135 314.837C45.0695 315.508 43.2075 315.5 42.0476 314.837C40.8878 314.174 40.8878 313.093 42.0318 312.422C43.1759 311.751 45.0379 311.759 46.1978 312.422Z",
    fill: "#FF3F83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.953 377.152L545.898 406.156L545.882 415.081C545.882 415.689 545.471 416.305 544.667 416.778C543.041 417.725 540.398 417.717 538.757 416.778C537.929 416.297 537.518 415.673 537.534 415.058L537.55 406.077L537.605 377.145C537.605 377.768 538.015 378.384 538.828 378.849C540.469 379.796 543.112 379.796 544.738 378.849C545.535 378.384 545.953 377.776 545.953 377.152Z",
    fill: "#9E0038"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.598 386.079L537.558 406.07C538.813 406.748 540.272 407.103 541.811 407.103C543.27 407.103 544.675 406.788 545.898 406.156L545.937 386.079H537.59H537.598Z",
    fill: "#9E0038"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.448 361.905L576.393 381.485C576.393 381.841 576.156 382.204 575.691 382.48C575.052 382.851 541.582 402.312 543.531 401.184L543.586 381.604L575.746 362.9C576.211 362.623 576.448 362.268 576.448 361.905Z",
    fill: "#2B9E31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.586 381.604L543.531 401.184C542.584 401.736 541.053 401.736 540.098 401.184C519.285 389.156 524.445 392.148 507.726 382.48C507.245 382.204 507 381.848 507 381.485L507.071 361.905C507.071 362.26 507.308 362.631 507.773 362.9L540.154 381.604C541.1 382.156 542.631 382.156 543.586 381.604Z",
    fill: "#99D89C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.737 360.911C576.692 361.464 576.692 362.348 575.745 362.9L543.578 381.596C542.631 382.149 541.1 382.149 540.146 381.596L507.773 362.9C506.818 362.348 506.818 361.464 507.765 360.911L539.933 342.215C540.879 341.663 542.41 341.663 543.365 342.215L575.737 360.911Z",
    fill: "#77CB7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.122 342.791L571.075 359.364C571.075 359.664 570.878 359.972 570.483 360.201L543.263 376.024L543.31 359.451L570.53 343.628C570.925 343.391 571.13 343.091 571.13 342.791H571.122Z",
    fill: "#2B9E31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.294 359.451L543.246 376.024C542.449 376.49 541.148 376.49 540.343 376.024L512.949 360.209C512.539 359.972 512.341 359.664 512.341 359.356L512.389 342.791C512.389 343.099 512.594 343.399 512.996 343.628L540.39 359.451C541.195 359.917 542.497 359.917 543.294 359.451Z",
    fill: "#99D89C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.513 341.946C571.318 342.412 571.326 343.162 570.521 343.627L543.301 359.451C542.504 359.916 541.202 359.916 540.397 359.451L513.003 343.627C512.198 343.162 512.19 342.412 512.995 341.946L540.216 326.123C541.012 325.657 542.314 325.657 543.119 326.123L570.513 341.946Z",
    fill: "#77CB7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.6 324.836L566.561 338.86C566.561 339.113 566.395 339.373 566.056 339.563L543.017 352.955L543.057 338.931L566.095 325.538C566.435 325.341 566.6 325.089 566.6 324.828V324.836Z",
    fill: "#2B9E31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.057 338.94L543.018 352.964C542.339 353.359 541.243 353.359 540.564 352.964L517.383 339.579C517.036 339.382 516.871 339.121 516.871 338.861L516.91 324.845C516.91 325.105 517.084 325.358 517.423 325.555L540.604 338.948C541.282 339.342 542.387 339.342 543.057 338.948V338.94Z",
    fill: "#99D89C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.088 324.126C566.767 324.521 566.775 325.16 566.096 325.547L543.058 338.94C542.379 339.334 541.282 339.334 540.604 338.94L517.415 325.547C516.737 325.152 516.729 324.513 517.407 324.126L540.446 310.733C541.125 310.339 542.221 310.339 542.9 310.733L566.088 324.126Z",
    fill: "#77CB7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.247 324.132C532.486 324.851 532.494 326.011 531.263 326.729C530.032 327.447 528.028 327.447 526.789 326.729C525.551 326.011 525.543 324.851 526.774 324.132C528.005 323.414 530.009 323.414 531.247 324.132Z",
    fill: "#FF3F83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547.105 327.711C548.123 328.295 548.131 329.249 547.113 329.841C546.103 330.425 544.454 330.425 543.436 329.841C542.418 329.257 542.411 328.302 543.42 327.711C544.43 327.126 546.079 327.119 547.097 327.711H547.105Z",
    fill: "#FF3F83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.198 316.422C547.35 317.085 547.358 318.166 546.214 318.837C545.069 319.508 543.207 319.5 542.048 318.837C540.888 318.174 540.888 317.093 542.032 316.422C543.176 315.751 545.038 315.759 546.198 316.422Z",
    fill: "#FF3F83"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5131_565625"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 584,
    height: 605.563,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPiccolo);
export default __webpack_public_path__ + "static/media/piccolo.07a3f010e3a4261cffdd3d02d76e0d75.svg";
export { ForwardRef as ReactComponent };